var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4997 11.6668C11.4201 11.6668 12.1663 10.9206 12.1663 10.0002C12.1663 9.07969 11.4201 8.3335 10.4997 8.3335C9.5792 8.3335 8.83301 9.07969 8.83301 10.0002C8.83301 10.9206 9.5792 11.6668 10.4997 11.6668Z",
    fill: "#8E97A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4997 6.66683C11.4201 6.66683 12.1663 5.92064 12.1663 5.00016C12.1663 4.07969 11.4201 3.3335 10.4997 3.3335C9.5792 3.3335 8.83301 4.07969 8.83301 5.00016C8.83301 5.92064 9.5792 6.66683 10.4997 6.66683Z",
    fill: "#8E97A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4997 16.6668C11.4201 16.6668 12.1663 15.9206 12.1663 15.0002C12.1663 14.0797 11.4201 13.3335 10.4997 13.3335C9.5792 13.3335 8.83301 14.0797 8.83301 15.0002C8.83301 15.9206 9.5792 16.6668 10.4997 16.6668Z",
    fill: "#8E97A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.e7b1d10a31ca11c2d7901199899ac041.svg";
export { ForwardRef as ReactComponent };